<template>
	<div id="content" class="content join join_done">
		<div class="container">

			<div class="page-title">
				<h2 class="tit">KAKAO 로그인 진행중</h2>
				<p class="sub-tit">KAKAO 인증이 진행중입니다. 잠시만 기다려 주세요.</p>
				<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "kakaoIOSReturn",
	data() {
		return {
			LOCAL: location.hostname,
		}
	},
	created() {
		var self = this;
		
		// code 파라미터 추출
		const code = new URL(window.location.href).searchParams.get("code");
		
		if (!code) {
			this.swalUtils.gritter("에러", "인증 코드를 받지 못했습니다.", "error", 2000, () => {
				//location.href = "/member/login";
			});
			return;
		}

		// 디버깅 정보 출력
		console.log("=== 카카오 iOS 로그인 디버깅 정보 ===");
		console.log("REST API KEY:", this.APIs.KAKAO_REST_API_LOGIN_KEY);
		console.log("Redirect URI:", this.APIs.KAKAO_IOS_LOGIN_RETURN);
		console.log("Authorization Code:", code);
		console.log("Current URL:", window.location.href);
		console.log("================================");

		// 백엔드를 통해 토큰 교환 및 사용자 정보 조회
		this.axiosCaller.post(this, this.APIs.OAUTH + '/kakao/token', {
			code: code,
			clientId: this.APIs.KAKAO_REST_API_LOGIN_KEY,
			redirectUri: this.APIs.KAKAO_IOS_LOGIN_RETURN
		}, (res) => {
			console.log("카카오 토큰 교환 및 사용자 정보 응답:", res);

			if (res.data && res.data.status === "ok" && res.data.userInfo) {
				const kakaoUserInfo = JSON.parse(res.data.userInfo);
								
								// 카카오 이메일 추출
								let email = null;
								if (kakaoUserInfo.kakao_account && kakaoUserInfo.kakao_account.email) {
									email = kakaoUserInfo.kakao_account.email;
								}

								this.axiosCaller.get(this, this.APIs.SESSION + "/doSnsLogin", {
									snsService: "kakao",
									snsId: kakaoUserInfo['id'],
									email: email,
									deviceToken: (this.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
								}, async (res) => {

									const result = res.data;

									if (result.status === "ok") {
										if (await this.setSessionProc(result.coAccountVO)) {
											self.setSessionKeep(this.isKeepSession);
											
											// SSO 모드 확인 (세션 스토리지에서 SSO 파라미터 가져오기)
											let ssoParams = null;
											try {
												const ssoParamsStr = sessionStorage.getItem('ssoParams');
												if (ssoParamsStr) {
													ssoParams = JSON.parse(ssoParamsStr);
													sessionStorage.removeItem('ssoParams'); // 사용 후 삭제
												}
											} catch (e) {
												console.log("SSO 파라미터 확인 실패:", e);
											}

											// SSO 모드면 SSO 처리
											if (ssoParams) {
												self.axiosCaller.post(self, self.APIs.SESSION + "/doSSOSnsLogin", {
													uuid: ssoParams.uuid,
													gid: ssoParams.gid,
													redirecturl: ssoParams.redirecturl
												}, (ssoRes) => {
													const ssoResult = ssoRes.data;
													if (ssoResult.status === "ok") {
														// 팝업으로 열렸다면 부모 창으로 결과 전달
														if (window.opener && !window.opener.closed) {
															window.opener.postMessage({
																key: "sso_login_success",
																redirectUrl: ssoResult.redirectUrl,
																code: ssoResult.redirectUrl ? ssoResult.redirectUrl.split("code=")[1]?.split("&")[0] : null
															}, location.origin);
															self.$nextTick(() => {
																window.opener.focus();
																window.close();
															});
														} else {
															// 일반 페이지로 열렸다면 직접 리디렉션
															location.href = ssoResult.redirectUrl;
														}
													} else {
														if (window.opener && !window.opener.closed) {
															window.opener.postMessage({
																key: "sso_login_fail",
																msg: ssoResult.msg || "SSO 로그인에 실패했습니다."
															}, location.origin);
															self.$nextTick(() => {
																window.opener.focus();
																window.close();
															});
														} else {
															self.swalUtils.fireSsoLicenseAuthGuide(ssoResult.msg);
														}
													}
												});
											} else {
												// 일반 모드
												self.goWithCoCode(self);
											}
										}
									} else {
										this.swalUtils.gritter("Error", result.msg, "question", 1500, () => {
											history.back()
										})
									}
								})


			} else {
				console.error("카카오 토큰 교환 및 사용자 정보 조회 실패:", res.data);
				const errorMsg = res.data?.msg || "카카오 로그인 처리에 실패했습니다.";
				this.swalUtils.gritter("에러", errorMsg, "error", 3000, () => {
					//location.href = "/member/login";
				});
			}
		}, (error) => {
			console.error("카카오 토큰 교환 에러:", error);
			const errorMsg = error.response?.data?.msg || error.message || "알 수 없는 오류";
			this.swalUtils.gritter("에러", "카카오 로그인 처리 중 오류가 발생했습니다. " + errorMsg, "error", 3000, () => {
				//location.href = "/member/login";
			});
		})
	},
	mounted() {
		this.appDeviceToken("#deviceToken")
	},
	methods: {
		goReferrer() {
			if (!this.stringUtils.isEmpty(this.$route.query.referrer)) {
				console.log(this.$route.query.referrer)
				location.href = this.$route.query.referrer
			} else {
				location.href = "/"
			}
		},
	}
}
</script>

<style scoped>

</style>
